module.exports = __webpack_public_path__ + "img/umc_banner.5e297e83.jpg";